import PropTypes from 'prop-types';
import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import Link from 'shared/components/Link';

import s from './BrandItem.css';

class BrandItem extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    count: PropTypes.number,
    onClick: PropTypes.func,
  };

  static defaultProps = {
    count: 0,
    onClick: null,
  };

  handleLinkClick = () => {
    if (this.props.onClick) {
      this.props.onClick();
    }
  };

  render() {
    const { title, link, count } = this.props;

    return (
      <Link
        onClick={this.handleLinkClick}
        to={link}
        className={s.root}
        data-lens-event={'carMakeClick'}
      >
        {title} <span className={s.count}>{count}</span>
      </Link>
    );
  }
}

export default withStyles(s)(BrandItem);



// WEBPACK FOOTER //
// ./src/desktop/components/BrandsList/BrandItem/BrandItem.js